"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allDiseaseTypes = exports.DiseaseType = exports.Disease = void 0;
const utility_1 = require("../utils/utility");
var Disease;
(function (Disease) {
    // studies
    Disease["OPADE"] = "OPADE";
})(Disease || (exports.Disease = Disease = {}));
var DiseaseType;
(function (DiseaseType) {
    DiseaseType["DISEASE"] = "DISEASE";
    DiseaseType["STUDY"] = "STUDY";
})(DiseaseType || (exports.DiseaseType = DiseaseType = {}));
exports.allDiseaseTypes = (0, utility_1.allEnumValues)({
    [Disease.OPADE]: Disease.OPADE,
});
